import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "raise-donors",
  class: "getRaiseDonorsClass"
}

import { AllComponents } from "@/builder/client/AllComponents";
import { PageType, PartialDisplayType } from "@/builder/enums";
import { PageDesign } from '@/builder/interfaces';
import { useRenderStore } from "@/builder/stores/renderStore";
import StretchyDots from "@/components/shared/animation/StretchyDots.vue";
import TestModeBanner from '@/components/shared/banner/TestModeBanner.vue';
import ToastContainer from '@/components/shared/toast/ToastContainer.vue';
import { computed, inject, onBeforeMount, onMounted, provide, ref } from "vue";
import { publicApiService } from "../../services/publicApiService";
import { setPageCssVariables } from "../utilities";
import { useSeoMeta } from "@unhead/vue";
import { Defaults } from "@/constants/Defaults";

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'ClientApp',
  props: {
    pageId: {},
    organizationId: {},
    environment: {}
  },
  setup(__props: any) {

const props = __props;

// inject
const renderStore = useRenderStore();
const publicApi = inject('publicApiService') as publicApiService;

const pageDesign = ref(renderStore.page.pageDesign);

const updatePageDesign = (newVal: PageDesign) => {
    pageDesign.value = newVal;
}

provide("pageDesign", pageDesign);

// refs
const organizationId = ref(Number.parseInt(props.organizationId));

// computed
const isEmbed = computed(() => renderStore.page.pageType !== PageType.Full);

const getRaiseDonorsClass = computed(() => {
    return isEmbed.value ? "raise-donors raise-donors-embed" : "raise-donors";
});

// lifecycle
onBeforeMount(async () => {
    try {
        const response = await publicApi.getPage(props.pageId, organizationId.value);
        renderStore.page = JSON.parse(atob(response.json));
        renderStore.pageResponse = response;

        useSeoMeta({
            ogType: 'website',
            ogDescription: renderStore.page.pageSettings.openGraphDescription,
            ogTitle: renderStore.page.pageSettings.openGraphTitle ?? renderStore.page.name,
            ogImage: renderStore.page.pageSettings.openGraphImageUrl ?? Defaults.defaultSocialMediaImage,
            twitterCard: 'summary_large_image',
        });

        setPageCssVariables(renderStore.page.pageDesign);
        updatePageDesign(renderStore.page.pageDesign);

        // Inject Google font for page if needed
        if (renderStore.page.pageDesign.fontFamily) {
            renderStore.loadGoogleFont(renderStore.page.pageDesign.fontFamily);

            //go through all components and load google fonts
            for (const component of renderStore.page.components) {
                if (component.styles.fontFamily) {
                    renderStore.loadGoogleFont(component.styles.fontFamily);
                }
            }
        }

        // Inject custom CSS
        if (renderStore.page.pageDesign.customCss) {
            const style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            style.appendChild(document.createTextNode(renderStore.page.pageDesign.customCss));
            document.head.appendChild(style);
        }

        // Inject custom JS
        if (renderStore.page.pageSettings.customJs) {
            const script = document.createElement('script');
            script.async = true;
            script.setAttribute('type', 'text/javascript');
            script.appendChild(document.createTextNode(renderStore.page.pageSettings.customJs));
            document.head.appendChild(script);
        }
    } catch (error) {
        console.error('Failed to load page data', error);
    }

    // Do this separately so we do not prevent the page from loading
    try {
        await publicApi.getOrganization(organizationId.value)
            .then((response) => {
                renderStore.organization = response;
                renderStore.setFavicon(response.faviconUrl);
            });
    } catch (error) {
        console.error('Failed to load organization data', error);
    }
});

onMounted(async () => {
    await renderStore.handleURLParameters();

    // If user is using tracking pixel, get visitor giving
    if (renderStore.page.useTrackingPixel) {
        try {
            renderStore.visitorGiving = await publicApi.findVisitor(organizationId.value);
        } catch (error) {
            renderStore.visitorGiving = null;
        }
    }
});

return (_ctx: any,_cache: any) => {
  return (isEmbed.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "raise-donors",
        class: _normalizeClass(getRaiseDonorsClass.value)
      }, [
        (_unref(renderStore).page.partialDisplayType !== _unref(PartialDisplayType).Modal)
          ? (_openBlock(), _createBlock(TestModeBanner, {
              key: 0,
              source: "public"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderStore).page.components, (component) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(AllComponents)[component.type]), {
            key: component.id,
            component: component
          }, null, 8, ["component"]))
        }), 128)),
        (_unref(renderStore).isProcessing)
          ? (_openBlock(), _createBlock(StretchyDots, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(ToastContainer, {
          position: "top-right",
          storeSelection: "renderStore"
        })
      ], 2))
    : (_openBlock(), _createElementBlock("main", _hoisted_1, [
        (_unref(renderStore).page.partialDisplayType !== _unref(PartialDisplayType).Modal)
          ? (_openBlock(), _createBlock(TestModeBanner, {
              key: 0,
              source: "public"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderStore).page.components, (component) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(AllComponents)[component.type]), {
            key: component.id,
            component: component
          }, null, 8, ["component"]))
        }), 128)),
        (_unref(renderStore).isProcessing)
          ? (_openBlock(), _createBlock(StretchyDots, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(ToastContainer, {
          position: "top-right",
          storeSelection: "renderStore"
        })
      ]))
}
}

})